<div class="modal fade" tabindex="-1" [id]="modalId"> </div>

<nz-modal
    [(nzVisible)]="isVisible"
    [nzTitle]="modalTitle"
    (nzOnCancel)="handleCancel()"
    (nzOnOk)="save()"
    [nzOkLoading]="isConfirmLoading"
    [nzOkDisabled]="form.invalid"
    [nzCancelDisabled]="isConfirmLoading"
    [nzMaskClosable]="!isConfirmLoading"
    [nzKeyboard]="!isConfirmLoading"
    [nzClosable]="!isConfirmLoading"
    nzOkText="Save"
    nzCancelText="Cancel"
    [nzWidth]="600"
    [nzFooter]="modalFooter">

    <ng-container *nzModalContent>
        @if (!canEdit) {
            <app-unauthorized-access-edit-warning></app-unauthorized-access-edit-warning>
        }
        <form nz-form [formGroup]="form" [nzLayout]="'horizontal'">
            
            <nz-form-item>
                <nz-form-label [nzSm]="6" [nzXs]="24" nzRequired>Name</nz-form-label>
                <nz-form-control [nzSm]="18" [nzXs]="24" nzErrorTip="Name is required (2-50 chars)">                    
                    <input nz-input formControlName="name" placeholder="Name" />
                </nz-form-control>
            </nz-form-item>

            <nz-form-item>
                <nz-form-label [nzSm]="6" [nzXs]="24">Description</nz-form-label>
                <nz-form-control [nzSm]="18" [nzXs]="24" nzErrorTip="Description length: 2-100 chars">                    
                    <textarea nz-input formControlName="description" placeholder="Description" rows="3"></textarea>
                </nz-form-control>
            </nz-form-item>

            <nz-form-item>
                <nz-form-label [nzSm]="6" [nzXs]="24" nzRequired>Logo</nz-form-label>
                <nz-form-control [nzSm]="18" [nzXs]="24" nzErrorTip="Please select a file from Google Drive">
                    
                    <app-drive-file-card
                        [canEdit]="canEdit"
                        [fileId]="form.value.logoDriveFileId"
                        [folderId]="form.value.logoDriveFolderId"
                        [fileName]="form.value.logoDriveFileName"
                        [fileLink]="form.value.logoDriveFileLink"
                        [showMetadata]="true"
                        [showRemove]="true"
                        iconType="picture"
                        (browse)="openDrivePicker('logo')"
                        (remove)="clearFile('logo')">
                    </app-drive-file-card>

                    <input type="hidden" formControlName="logoDriveFileId">
                    <input type="hidden" formControlName="logoDriveFolderId">
                    <input type="hidden" formControlName="logoDriveFileName">
                    <input type="hidden" formControlName="logoDriveFileLink">

                </nz-form-control>
            </nz-form-item>

            <nz-form-item>
                <nz-form-label [nzSm]="6" [nzXs]="24" nzRequired>Brochure</nz-form-label>
                <nz-form-control [nzSm]="18" [nzXs]="24" nzErrorTip="Please select a file from Google Drive">
                    
                    <app-drive-file-card
                        [canEdit]="canEdit"
                        [fileId]="form.value.brochureDriveFileId"
                        [folderId]="form.value.brochureDriveFolderId"
                        [fileName]="form.value.brochureDriveFileName"
                        [fileLink]="form.value.brochureDriveFileLink"
                        [showMetadata]="true"
                        [showRemove]="true"
                        iconType="file-pdf"
                        iconColor="#eb2f96"
                        (browse)="openDrivePicker('brochure')"
                        (remove)="clearFile('brochure')">
                    </app-drive-file-card>

                    <input type="hidden" formControlName="brochureDriveFileId">
                    <input type="hidden" formControlName="brochureDriveFolderId">
                    <input type="hidden" formControlName="brochureDriveFileName">
                    <input type="hidden" formControlName="brochureDriveFileLink">

                </nz-form-control>
            </nz-form-item>

            <nz-form-item>
                <nz-form-label [nzSm]="6" [nzXs]="24" nzRequired>Datasheet</nz-form-label>
                <nz-form-control [nzSm]="18" [nzXs]="24" nzErrorTip="Please select a file from Google Drive">
                    
                    <app-drive-file-card
                        [canEdit]="canEdit"
                        [fileId]="form.value.datasheetDriveFileId"
                        [folderId]="form.value.datasheetDriveFolderId"
                        [fileName]="form.value.datasheetDriveFileName"
                        [fileLink]="form.value.datasheetDriveFileLink"
                        [showMetadata]="true"
                        [showRemove]="true"
                        iconType="file-pdf"
                        iconColor="#eb2f96"
                        (browse)="openDrivePicker('datasheet')"
                        (remove)="clearFile('datasheet')">
                    </app-drive-file-card>

                    <input type="hidden" formControlName="datasheetDriveFileId">
                    <input type="hidden" formControlName="datasheetDriveFolderId">
                    <input type="hidden" formControlName="datasheetDriveFileName">
                    <input type="hidden" formControlName="datasheetDriveFileLink">

                </nz-form-control>
            </nz-form-item>

            <nz-form-item>
                <nz-form-label [nzSm]="6" [nzXs]="24">Link</nz-form-label>
                <nz-form-control [nzSm]="18" [nzXs]="24">
                    <input nz-input formControlName="link" placeholder="Link" />
                </nz-form-control>
            </nz-form-item>

        </form>
    </ng-container>

    <ng-template #modalFooter>
        <button nz-button nzType="default" (click)="handleCancel()">Close</button>
        @if (canEdit) {
            <button nz-button nzType="primary" [nzLoading]="isConfirmLoading" (click)="save()">Save</button>
        }
    </ng-template>

</nz-modal>

<app-drive-file-picker-modal (fileSelected)="onDriveFileSelected($event)"></app-drive-file-picker-modal>